import PathwayCardList from 'components/PathwayCardList/PathwayCardList'
import CollectionHeader from 'components/shared/CollectionHeader/CollectionHeader'
import PropTypes from 'prop-types'

import './Collection.scss'
import Decoration from './images/Decoration'

export const Collection = ({ collection, locale }) => {
  const {
    additionalPathsDescription = null,
    additionalPathsTitle = null,
    additionalPathways = [],
    pathways = [],
    slug,
    theme,
  } = collection
  return (
    <div className="c-collection">
      <CollectionHeader
        title={collection.title}
        subtitle={collection.description}
        imageLeft={true}
        slug={slug}
        theme={theme?.length && theme[0].name}
      />
      <div className="c-collection__paths-wrapper" id="skiptocontent">
        <PathwayCardList
          locale={locale}
          pathways={pathways}
          className="c-collection__paths c-collection__paths--decorated"
          translateTitles={false}
          translateDescriptions={false}
        />
        <Decoration className="c-collection__paths-decoration" />
      </div>
      {additionalPathways.length > 0 && (
        <>
          {additionalPathsTitle && (
            <h2 className="c-collection__additional-paths-heading">
              {additionalPathsTitle}
            </h2>
          )}
          {additionalPathsDescription && (
            <p className="c-collection__additional-paths-description">
              {additionalPathsDescription}
            </p>
          )}
          <PathwayCardList
            locale={locale}
            pathways={additionalPathways}
            className="c-collection__paths"
            translateTitles={false}
            translateDescriptions={false}
          />
        </>
      )}
    </div>
  )
}

Collection.propTypes = {
  collection: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
}

export default Collection
